import { useState, useContext, createContext } from "react"

// Initial state
const initialState = {
    back: null,
    setBack: () => { },
    prevLocation: "",
    setPrevLocation: () => { }
}

// Page context
export const PageContext = createContext(initialState)

// Provider
export const PageProvider = ({ children }) => {
    const [back, setBack] = useState(null)

    const [prevLocation, setPrevLocation] = useState("")

    const value = {
        back,
        setBack,
        prevLocation,
        setPrevLocation
    }

    return (
        <PageContext.Provider value={value}>
            {children}
        </PageContext.Provider>
    )
}

export const usePage = () => {
    return useContext(PageContext)
}